export interface NotificationItem {
  id: string;
  type: string;
  title: string;
  message: string;
  read: boolean;
  createdAt: string;
}

export function getNotificationActionRoute(
  notification: Partial<NotificationItem>,
  role: 'MEMBER' | 'PROVIDER' | 'AGENT' | string
): { path: string; label: string } {
  const type = (notification.type || '').toLowerCase();
  const title = (notification.title || '').toLowerCase();
  const message = (notification.message || '').toLowerCase();
  const userRole = (role || 'MEMBER').toUpperCase();

  // 1. Proposals & Quotes
  if (type.includes('proposal') || title.includes('proposal') || message.includes('proposal') || title.includes('quote')) {
    if (userRole === 'PROVIDER') return { path: '/provider/saved-estimates', label: 'View Proposal / Estimate' };
    if (userRole === 'AGENT') return { path: '/agent/cost-estimator', label: 'View Proposal / Estimator' };
    return { path: '/member/agents', label: 'View Proposal Details' };
  }

  // 2. Cost Estimates
  if (type.includes('estimate') || title.includes('estimate') || message.includes('estimate') || title.includes('gfe')) {
    if (userRole === 'PROVIDER') return { path: '/provider/saved-estimates', label: 'Open Saved Estimates' };
    if (userRole === 'AGENT') return { path: '/agent/cost-estimator', label: 'Open Cost Estimator' };
    return { path: '/member/saved-estimates', label: 'View Good Faith Estimate' };
  }

  // 3. Appointments
  if (type.includes('appointment') || title.includes('appointment') || message.includes('appointment') || title.includes('booking')) {
    if (userRole === 'PROVIDER') return { path: '/provider/appointments', label: 'Manage Appointments' };
    if (userRole === 'AGENT') return { path: '/agent/dashboard', label: 'View Dashboard' };
    return { path: '/member/appointments', label: 'View Appointment' };
  }

  // 4. Care Team
  if (type.includes('care') || type.includes('team') || title.includes('care team') || message.includes('care team')) {
    if (userRole === 'PROVIDER') return { path: '/provider/patients', label: 'View Patient Care Team' };
    if (userRole === 'AGENT') return { path: '/agent/members', label: 'View Assigned Members' };
    return { path: '/member/care-team', label: 'View Care Team' };
  }

  // 5. Group Invitations & Team
  if (type.includes('group') || title.includes('group') || title.includes('team invitation')) {
    if (userRole === 'PROVIDER') return { path: '/provider/team', label: 'View Provider Team' };
    if (userRole === 'AGENT') return { path: '/agent/dashboard', label: 'View Dashboard' };
    return { path: '/member/dashboard', label: 'View Dashboard' };
  }

  // 6. ID Cards & Membership
  if (type.includes('id_card') || title.includes('id card') || message.includes('id card') || title.includes('membership')) {
    if (userRole === 'PROVIDER') return { path: '/provider/patients', label: 'View Patients' };
    if (userRole === 'AGENT') return { path: '/agent/members', label: 'View Members' };
    return { path: '/member/membership-card', label: 'View Digital ID Card' };
  }

  // 7. Reviews & Ratings
  if (type.includes('review') || title.includes('review')) {
    if (userRole === 'PROVIDER') return { path: '/provider/reviews', label: 'View Patient Reviews' };
    if (userRole === 'AGENT') return { path: '/agent/dashboard', label: 'View Dashboard' };
    return { path: '/member/search', label: 'Browse Providers' };
  }

  // Fallback default navigation by role
  if (userRole === 'PROVIDER') return { path: '/provider/dashboard', label: 'Go to Dashboard' };
  if (userRole === 'AGENT') return { path: '/agent/dashboard', label: 'Go to Dashboard' };
  return { path: '/member/dashboard', label: 'Go to Dashboard' };
}
